import type { BalanceReportListParams, BalanceReportSortKey } from '../types/pages'

export const DEFAULT_BALANCE_REPORT_LIST_PARAMS: BalanceReportListParams = {
  page: 1,
  perPage: 15,
  sortBy: 'desc',
  orderBy: 'applicant_id',
  q: '',
  company_id: '',
  property_id: '',
  application_status: 'APPROVED',
  amount_condition: '',
  payment_amount: '',
  chargeback_type: 'CONTRACTS',
  fromDt: '',
  toDt: '',
}

export const BALANCE_REPORT_SORT_COLUMNS: { key: BalanceReportSortKey; label: string }[] = [
  { key: 'applicant_id', label: 'Application ID' },
  { key: 'first_name', label: 'Name' },
  { key: 'company_name', label: 'Company' },
  { key: 'property_name', label: 'Property' },
  { key: 'rent_amount', label: 'Rent Amount' },
  { key: 'payment_amount', label: 'Amount Paid' },
  { key: 'payment_refund', label: 'Refunds' },
  { key: 'chargeback_exist', label: 'Chargebacks' },
  { key: 'balance_due', label: 'Balance Owed' },
  { key: 'application_status', label: 'Application Status' },
  { key: 'contract_start_date', label: 'Lease Start Date' },
  { key: 'payment_date', label: 'Last Activity Date' },
]
